module.exports = __webpack_public_path__ + "static/img/106.7f03641.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/201224/106.jpg
// module id = v0n4
// module chunks = 0